export default function BeforeAfterCases() {
  const cases = [
    {
      title: 'Reabilitação Oral Completa',
      description: 'Transformação completa com implantes e próteses',
      before: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/189e9e2437993868f8810ea1525c86e2.png',
      after: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/95adde5f90ef725d61047ee24c5158cd.png',
      disclaimer: 'Resultados podem variar de acordo com cada caso clínico.'
    },
    {
      title: 'Harmonização Orofacial',
      description: 'Equilíbrio facial com técnicas avançadas',
      before: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/c10ad3f2f7066ea38901769071aa8bd0.jpeg',
      after: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/8cb6177bd9f3bfe093e563c0a6b26bb5.jpeg',
      disclaimer: 'Procedimento realizado por cirurgião especializado.'
    },
    {
      title: 'Cirurgia Ortognática',
      description: 'Cirurgia na qual conseguimos tratar não só a estética facial do paciente mas também à função mastigatória e respiratória dos nossos pacientes',
      before: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/7a5b0e70bbb6505be580cac7e9b08359.png',
      after: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/44ccbcb207b203ab232db5a655260d29.png',
      disclaimer: 'Tratamento personalizado conforme necessidade do paciente.'
    }
  ];

  return (
    <section id="resultados" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-4">
            Antes e Depois
          </h2>
          <p className="text-lg text-[#5A5A5A] max-w-3xl mx-auto">
            Veja as transformações reais alcançadas com os tratamentos especializados 
            do Dr. Luiz Renato Kreb. Cada resultado reflete nosso compromisso com a excelência.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cases.map((case_, index) => (
            <div 
              key={index}
              className="bg-[#3A3A3A]/95 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-stagger-fade"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Case Title */}
              <div className="p-6 pb-4">
                <h3 className="text-xl font-semibold text-white mb-2">
                  {case_.title}
                </h3>
                <p className="text-gray-300 text-sm">
                  {case_.description}
                </p>
              </div>

              {/* Before/After Images */}
              <div className="grid grid-cols-2 gap-0">
                <div className="relative">
                  <img
                    src={case_.before}
                    alt={`Antes - ${case_.title}`}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-2 left-2 bg-red-600 text-white px-2 py-1 rounded text-xs font-medium">
                    ANTES
                  </div>
                </div>
                <div className="relative">
                  <img
                    src={case_.after}
                    alt={`Depois - ${case_.title}`}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-2 right-2 bg-[#6B2432] text-white px-2 py-1 rounded text-xs font-medium">
                    DEPOIS
                  </div>
                </div>
              </div>

              {/* Disclaimer */}
              <div className="p-6 pt-4">
                <p className="text-gray-400 text-xs italic">
                  {case_.disclaimer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
